import { NavigateTo, NAVIGATE_TO } from './types'

export const navigateTo: (path: string) => NavigateTo = path => ({
  type: NAVIGATE_TO,
  payload: { path }
})
